import { makeStyles } from '@mui/styles';

import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  showBackBtnSelector,
  getPageName,
} from "../../../store/selectors/view.selectors";

const BackButton = () => {
  const history = useHistory();
  const show = useSelector(showBackBtnSelector);
  const pageName = useSelector(getPageName);
  const btnClick = () => {
    history.goBack();
  };
  const classes = useStyles();
  return !!show ? (
    <div className={classes.container}>
      <svg
        onClick={btnClick}
        id="arrow"
        xmlns="http://www.w3.org/2000/svg"
        className={classes.btn}
        width="13.942"
        height="14"
        viewBox="0 0 13.942 14"
      >
        <path
          id="Path_677"
          data-name="Path 677"
          d="M2113.134,5081l1.3-1.485-3.966-4.525h10.472v-1.98H2110.47l3.966-4.525-1.3-1.485-6.134,7Z"
          transform="translate(-2107 -5067)"
          fill="#2e3f58"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1"
        height="33.5"
        viewBox="0 0 1 33.5"
        className={classes.sperator}
      >
        <line
          id="Line_2188"
          data-name="Line 2188"
          y2="33.5"
          transform="translate(0.5)"
          fill="none"
          stroke="#e0e0e0"
          strokeWidth="1"
        />
      </svg>
      <span className={classes.text}>{pageName}</span>
    </div>
  ) : (
    <></>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    flex: "0 0 100%",
    justifyContent: "start",
    alignItems: "center",
    height: 30,
  },
  btn: {
    marginRight: "18px",
    "&:hover, &:focus": {
      cursor: "pointer",
    },
  },
  sperator: {
    marginRight: "18px",
  },

  text: {
    font: "normal normal 600 15px/26px Open Sans",
    letterSpacing: "0.3px",
    color: "#333333",
    textTransform: "capitalize",
    opacity: 1,
  },
});
export default BackButton;
